import { signal } from '@preact/signals';

export const toastMsg = signal<string>('');
let timer: ReturnType<typeof setTimeout> | undefined;

/** Show a transient message (auto-dismiss 4s). Plain text only — rendered as textContent. */
export function toast(msg: string): void {
  toastMsg.value = msg;
  clearTimeout(timer);
  timer = setTimeout(() => (toastMsg.value = ''), 4000);
}
